// extracted by mini-css-extract-plugin
export default {"bnnr":"ProPage_bnnr__TK4TB"};